import React, { FC, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import styled from 'styled-components';
import isNil from 'lodash/isNil';

import { getLoanFormatFromCampaignProductsUrl } from '../utils/utils-url-to-loanformat';
import AgeCategorySelector from '../common/AgeCategorySelector';
import { changeLoanFormat } from '../../store/loanFormat/actions';
import LoanFormatDropDown from './LoanFormatDropDown';
import { LinkContainer } from './NavigationLinksContainer';
import TitleDropdown from './TitleDropdown';
import SubNavigationLayout from './SubNavigationLayout';
import { LoanFormatState } from '../../store/loanFormat/state';
import { AppDispatch } from '../../store';
import { NavigationLink } from './NavigationLink';
import { AppState } from '../../store/appState';
import { useTranslation } from 'react-i18next';

const StDropDownContainer = styled.div`
    display: flex;
    justify-content: flex-start;
`;

const StAgeCategorySelector = styled(AgeCategorySelector)`
    margin-left: 10px;
`;

type Props = {
    readonly isSticky?: boolean;
};

const UnlimitedNavigation: FC<Props> = ({ isSticky }) => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const dispatch = useDispatch<AppDispatch>();
    const loanFormat = useSelector(selectLoanFormat);

    useEffect(() => {
        const loanFormatFromUrl = getLoanFormatFromCampaignProductsUrl(pathname);
        if (!isNil(loanFormatFromUrl) && loanFormat.key !== loanFormatFromUrl.key) {
            dispatch(changeLoanFormat(loanFormatFromUrl));
        }
    });

    const loanFormatKey = loanFormat?.key ?? 'all';
    const lowerLoanFormat = loanFormatKey.toLowerCase();

    return (
        <SubNavigationLayout
            left={<TitleDropdown isCampaigns={true} locationPathname={undefined} />}
            center={
                <LinkContainer>
                    <li>
                        <NavigationLink to={`/unlimited/campaigns/${lowerLoanFormat}`}>
                            {t('menu.shop.unlimited.campaigns')}
                        </NavigationLink>
                    </li>
                </LinkContainer>
            }
            right={
                !isSticky && (
                    <StDropDownContainer>
                        <LoanFormatDropDown showIcons={false} />
                        <StAgeCategorySelector />
                    </StDropDownContainer>
                )
            }
            isSticky={isSticky}
            width="50"
        />
    );
};

export default UnlimitedNavigation;

function selectLoanFormat(state: AppState): LoanFormatState {
    return state.loanFormat;
}
